import styled from 'styled-components';
import NextAnchor from '../NextAnchor';

// Numbers are links, but a page of underlined numbers reads as noise, so it shows on hover.
const ChartLink = styled(NextAnchor)`
    text-decoration: none;

    &:hover { text-decoration: underline; }
`;

export default ChartLink;
